<template>
    <div
        v-if="carArticleList && carArticleList.length"
        class="feeds"
        ref="feeds"
        data-type="anchor"
        data-anchor="feeds"
    >
        <h3 class="title">精彩资讯</h3>
        <div class="feeds-content">
            <div
                v-for="item in carArticleList"
                :key="item.id"
                class="feeds-link"
            >
                <router-link
                    class="feeds-link-left"
                    :to="routerParse(item)"
                    target="_blank"
                    @click.native="logFeedsClick(item)"
                >
                    <img src="@/assets/images/bitmap-small.png" v-real-src="item.thumbnail && item.thumbnail[0] && item.thumbnail[0].pic_url">
                    <p v-if="item.contentType == 2" class="feeds-link-video">
                        <img src="@/common/images/car-train/play.svg">
                        <span>{{item.duration_display}}</span>
                    </p>
                </router-link>
                <router-link
                    class="feeds-link-right"
                    :to="routerParse(item)"
                    target="_blank"
                    @click.native="logFeedsClick(item)"
                >
                    <p class="feeds-link-title c-line-clamp2">{{item.title}}</p>
                    <p class="feeds-link-medium">
                        <span>{{item.authorName}}</span>
                        <span>{{item.public_time}}</span>
                    </p>
                </router-link>
            </div>
        </div>
        <c-pull-up-loading
            v-if="loading || articleComplete"
            :loading="loading"
            :complete="articleComplete"
        />
    </div>
</template>

<script>
/**
 * @file
 * @author guozhihao02
 */
import request from 'http/request';
import URLS from 'http/URLS';
import {mapState} from 'vuex';
import {throttle} from 'lodash';
import {on, off} from 'js/Utils';
import {elementInViewport, sendLog} from 'js/log';
import pullUpLoading from 'components/pull-up-loading';

const PAGE_SIZE = 14;

export default {
    components: {
        'c-pull-up-loading': pullUpLoading
    },
    data() {
        return {
            loading: false,
            articleComplete: false,
            scrollTop: 0, // 用于判断横向滚动
            refreshCountObj: null,
            carArticleList: [],
            stopRequest: false
        };
    },
    props: {
        carInfoSimple: {
            type: Object,
            default: () => {}
        },
        urlParams: {
            type: Object,
            default: () => {}
        },
        carSeriesInfo: {
            type: Object,
            default: () => {}
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.getseriesarticle();
        });
    },
    activated() {
        this.stopRequest = false;
        on(window, 'scroll', this.infiniteLoad);
    },
    deactivated() {
        this.stopRequest = true;
        off(window, 'scroll', this.infiniteLoad);
    },
    beforeDestroy() {
        off(window, 'scroll', this.infiniteLoad);
    },
    methods: {
        infiniteLoad: throttle(function () {
            if (this.$refs.feeds && this.elementInViewportFirst) {
                // 展现日志
                this.elementInViewportFirst = !elementInViewport(
                    this.$refs.feeds,
                    'car_train_feeds_show',
                    {...this.carInfoSimple}
                );
            }
            if (this.articleComplete) {
                return;
            }
            if (!this.loading) {
                let scrollY = window.pageYOffset
                    || document.documentElement.scrollTop
                    || document.body.scrollTop;
                if (this.scrollTop !== scrollY) {
                    this.needsGetNewData();
                }
            }
        }, 150, {leading: false}),
        needsGetNewData() {
            let scrollY = window.pageYOffset
                || document.documentElement.scrollTop
                || document.body.scrollTop;
            let scrollHeight = document.documentElement.scrollHeight
                || document.body.scrollHeight;
            let screenHeight = window.innerHeight
                || document.documentElement.clientHeight
                || document.body.clientHeight;
            if (scrollHeight - scrollY < screenHeight + 100) {
                this.scrollTop = scrollY;
                this.getseriesarticle();
            }
        },
        getseriesarticle() {
            if (this.loading) {
                return;
            }
            this.loading = true;
            const refreshCountObj = this.refreshCountObj
                || {
                    refreshCount: 0,
                    refreshIndex: 0,
                    sessionId: +new Date(),
                    lastUpdateTime: +new Date()
                };
            this.refreshCountObj = refreshCountObj;
            const params = {
                appname: '有驾',
                ua: navigator.userAgent.replace(/\s/g, ''),
                // ut取不到，所以写死一个
                ut: encodeURIComponent('iPhone 8 plus <iPhone10,2>') + '_' + encodeURIComponent('iOS 11.4'),
                uid: this.uid,
                network: '1_0',
                bdvc: 0,
                time: this.firstRequestTime || (this.firstRequestTime = +new Date()),
                ...this.urlParams
            };
            const info = {
                'location_type': 0
            };
            if (location.lat) {
                info.location = `${location.lat},${location.long},--460-00`;
            }
            request(URLS.GETSERIESREC, params, {
                method: 'POST',
                headers: {
                    'content-type': 'application/x-www-form-urlencoded'
                },
                data: {
                    data: JSON.stringify({
                        'tab_id': 14007,
                        'tab_name': '推荐',
                        'last_update_time': refreshCountObj.lastUpdateTime,
                        'refresh_state': '5',
                        'refresh_index': refreshCountObj.refreshIndex, // 只有一个tab, 故refresh_index===refresh_count
                        'refresh_count': refreshCountObj.refreshCount,
                        'guide_refresh': '0',
                        'pull_to_refresh_count': '0'
                    }),
                    info: JSON.stringify(info)
                }
            })
                .then(res => {
                    const Result = res.Result;
                    this.carArticleList = [...this.carArticleList, ...(Result || [])];
                    this.loading = false;
                    // this.currentPage += 1;
                    if (Result.length < PAGE_SIZE) {
                        this.articleComplete = true;
                    }
                    // 更新刷新次数
                    let now = +new Date();
                    if (now - refreshCountObj.lastUpdateTime > 1800000) {
                        refreshCountObj.sessionId = +new Date();
                        refreshCountObj.refreshIndex = 0;
                        if (now - refreshCountObj.lastUpdateTime > 24 * 3600000) {
                            refreshCountObj.refreshCount = 0;
                        }
                        else {
                            refreshCountObj.refreshCount = refreshCountObj.refreshCount++;
                        }
                    }
                    else {
                        refreshCountObj.refreshIndex = ++refreshCountObj.refreshIndex;
                        refreshCountObj.refreshCount = ++refreshCountObj.refreshCount;
                    }
                    refreshCountObj.lastUpdateTime = now;
                    this.refreshCountObj = refreshCountObj;

                    this.$emit('getdatastatus', 'feeds', Result.length > 0);
                    if (this.stopRequest || this.articleComplete) {
                        return;
                    }
                    this.$nextTick(() => {
                        this.needsGetNewData();
                    });
                })
                .catch(() => {
                    this.$emit('getdatastatus', 'feeds', false);
                });
        },
        routerParse(item) {
            if (item.contentType === 2) {
                return {
                    name: 'VIDEO_DETAIL',
                    query: {
                        serid: this.carSeriesInfo.id,
                        sername: this.carSeriesInfo.name
                    },
                    params: {
                        nid: item.nid
                    }
                };
            }
            else if (item.contentType === 1) {
                return {
                    name: 'ARTICLE_DETAIL',
                    query: {
                        serid: this.carSeriesInfo.id,
                        sername: this.carSeriesInfo.name
                    },
                    params: {
                        nid: item.nid
                    }
                };
            }
            // 直接跳转到提供的地址
            return item.url;
        },
        logFeedsClick(item) {
            sendLog('car_train_feeds_click', {
                ...this.carInfoSimple,
                nid: item.nid,
                type: +item.contentType === 1
                    ? '图文' : +item.contentType === 2
                    ? '视频' : '其他'
            });
        }
    },
    computed: {
        ...mapState({
            uid: 'uid'
        })
    }
};
</script>

<style lang="less" scoped>
.feeds-content {
    .feeds-link {
        display: flex;
        // width: 100%;
        height: 100px;
        margin-top: 24px;
        &:first-child {
            margin-top: 0;
        }
        .feeds-link-left {
            position: relative;
            width: 150px;
            cursor: pointer;
            overflow: hidden;
            >img {
                height: 100px;
            }
            .feeds-link-video {
                position: absolute;
                right: 5px;
                bottom: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 6px 7px;
                font-size: 12px;
                line-height: 12px;
                border-radius: 30px;
                color: #FFFFFF;
                background: rgba(0, 0, 0, .4);
                img {
                    margin-right: 4px;
                }
            }
        }
        .feeds-link-right {
            display: flex;
            margin-left: 24px;
            justify-content: center;
            flex-direction: column;
            max-width: 681px;
            cursor: pointer;
            .feeds-link-title {
                font-size: 20px;
                line-height: 25px;
                color: #333333;
            }
            .feeds-link-medium {
                margin-top: 15px;
                font-size: 14px;
                line-height: 14px;
                color: #999999;
                span {
                    margin-right: 18px;
                }
            }
        }
    }
}
</style>
